import React from "react"
import shortid from "shortid"

import { Box, Button, FlexGrid, Heading, Paragraph, Wrapper } from "components"

import CustomCheckbox from "./_customCheckbox"
import { navigate } from "gatsby"

const SelectorSection = ({ data, currentExperience, setCurrentExperience }) => {
  const uid = shortid.generate()

  return (
    <>
      <Wrapper id="howDoYouDT-selector">
        <Box
          as="form"
          onSubmit={e => {
            e.preventDefault()
            if (currentExperience) {
              navigate("/experiences/" + currentExperience + "/")
            }
          }}
        >
          <Box>
            <FlexGrid
              content={data.experiences.map(
                ({ url, experience, description }) => {
                  return {
                    width: ["100%", null, "50%"],
                    children: (
                      <CustomCheckbox
                        name={uid}
                        size={600}
                        value={currentExperience}
                        onClick={() => {
                          setCurrentExperience(url)
                        }}
                        checked={currentExperience === url}
                      >
                        <Heading
                          size={500}
                          fontSize={["16px !important", "24px !important"]}
                          lineHeight={["24px !important", "32px !important"]}
                        >
                          {experience}
                        </Heading>
                        <Paragraph size={500}>{description}</Paragraph>
                      </CustomCheckbox>
                    ),
                  }
                }
              )}
              gutterY={[4]}
            />
          </Box>

          <Button
            iconAfter="arrowRight"
            intent="primary"
            appearance="primary"
            mt={["layout.4", "layout.6"]}
            disabled={currentExperience === ""}
            type="submit"
          >
            Explore
          </Button>
        </Box>
      </Wrapper>
    </>
  )
}

export default SelectorSection
